import { Button, Select, Table, Typography, Pagination, Input } from 'antd'
import React, { useEffect, useState } from 'react'
import { Link, useLoaderData } from 'react-router-dom'

const columns = [
  {
    title: 'Date',
    dataIndex: 'date',
    key: 'date',
    className: 'whitespace-nowrap font-medium text-sky-600 dark:text-white',
    render: (_, record) => <span>{`${new Date(record.date).toLocaleDateString()}`}</span>
  },
  {
    title: 'Description',
    dataIndex: 'description',
    key: 'description',
    className: 'whitespace-nowrap font-medium text-sky-600 dark:text-white'
  },
  // {
  //   title: 'Reference',
  //   dataIndex: 'reference',
  //   key: 'reference',
  //   className: 'whitespace-nowrap font-medium text-sky-600 dark:text-white'
  // },
  {
    title: 'Amount',
    dataIndex: 'amount',
    key: 'amount',
    className: 'whitespace-nowrap font-medium text-sky-600 dark:text-white'
  },
  {
    title: 'Action',
    key: 'operation',
    fixed: 'right',
    width: 100,
    className: 'whitespace-nowrap font-medium text-dark-600 dark:text-white',
    render: (_, record) => (
      <Link className='h-full w-full' to={'/accounting/analytic-items/'+record.number.replaceAll('/', '-')}>
        EDIT
      </Link>
    )
  }
]

const options = []
for (let i = 10; i < 36; i++) {
  options.push({
    value: i.toString(36) + i,
    label: i.toString(36) + i
  })
}
const handleChange = (value) => {
  console.log(`Selected: ${value}`)
}

const AnalyticItems = () => {
  const analyticItems = useLoaderData()
  const [current, setCurrent] = useState(3)
  const onChange = (page) => {
    console.log(page)
    setCurrent(page)
  }

  
  // accounts.forEach((_, idx) => (accounts[idx]['key'] = idx))

  return (
    <div>
      <div className='flex justify-between mx-4'>
        <h3 className='font-bold'>Analytic Items</h3>
        <div className=' bg-white dark:bg-gray-900'>
          {/* <Input addonBefore={<MdFilterAlt />}  defaultValue="mysite" /> */}

          <Select
            mode='multiple'
            size={'middle'}
            placeholder='Filter'
            // defaultValue={['a10', 'c12']}
            onChange={handleChange}
            className='w-96'
            options={options}
          />
        </div>
      </div>
      <div className='columns-2 mx-4 my-2'>
        <div className='column'>
          <Button className='' size={'sm'}>
            <Link to={'/accounting/analytic-items/new'} className='w-full'>
              New
            </Link>
          </Button>
        </div>
        <div className='dark:bg-gray-900 column'>
          <div className='flex justify-end'>
            <Pagination current={current} onChange={onChange} total={50} />
          </div>
        </div>
      </div>
      <Table
        dataSource={analyticItems}
        columns={columns}
        scroll={{ x: 1500 }}
        pagination={false}
        rowKey={'name'}
      />
    </div>
  )
}

export default AnalyticItems;
